import { Cache } from "memory-cache";
import { CorporationStructureEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationStructureEntity(id: number): Promise<CorporationStructureEntity | null> {
  let entity: any = await cache.get(id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationStructureEntity(structure: CorporationStructureEntity) {
  cache.put(structure.props.structure_id.toString(), structure, 60 * 60 * 1000 /* 1 hour */);
}
